/* OrgsComboBoxRenderer.js */

"use strict";
const Renderer = require("@gluenetworks/combobox").Renderer;
const _ = require("lodash");

class OrgsComboRenderer extends Renderer {
    constructor(val) {
        super(val);
    }

    shutdown() {
        return super.shutdown();
    }

    _onKeyDownEvent(event) {
        let keycode = event.keyCode,
            enterKey = 13,
            downArrow = 40,
            upArrow = 38,
            commandKey1 = 91,
            commandKey2 = 93;

        if (keycode === commandKey1 || keycode === commandKey2) {
            this._commandKeyDown = true;
        }

        if (this._optionsOpen === true) {
            let userSelectedValue = this._selectList.getUserSelected(),
                value = this._model.getValue(),
                options = this._selectList.getOptions(),
                userSelectionFound = false;
            if (
                keycode === downArrow ||
                (userSelectedValue === undefined && keycode === enterKey)
            ) {
                for (let i = 0; i < options.length; i++) {
                    let currentOption = options[i];
                    if (_.isUndefined(userSelectedValue)) {
                        if (currentOption.disabled !== true) {
                            this._selectList.userSelected = currentOption.value;
                            break;
                        }
                    } else {
                        if (currentOption.value === userSelectedValue) {
                            userSelectionFound = true;
                            continue;
                        }
                        if (userSelectionFound === true) {
                            if (currentOption.disabled !== true) {
                                this._selectList.userSelected = currentOption.value;
                                break;
                            }
                        }
                    }
                }
                event.stopImmediatePropagation();
            } else if (keycode === upArrow) {
                for (let i = options.length - 1; i >= 0; i--) {
                    let currentOption = options[i];
                    if (_.isUndefined(userSelectedValue)) {
                        if (currentOption.disabled !== true) {
                            this._selectList.userSelected = currentOption.value;
                            break;
                        }
                    } else {
                        if (currentOption.value === userSelectedValue) {
                            userSelectionFound = true;
                            continue;
                        }
                        if (userSelectionFound === true) {
                            if (currentOption.disabled !== true) {
                                this._selectList.userSelected = currentOption.value;
                                break;
                            }
                        }
                    }
                }
                event.stopImmediatePropagation();
            } else if (keycode === enterKey) {
                if (this._model.multiple === true) {
                    let valueExists = false;
                    value.forEach((val, index) => {
                        if (val === userSelectedValue) {
                            value.splice(index, 1);
                            valueExists = true;
                        }
                    });
                    if (!valueExists) {
                        value.push(userSelectedValue);
                    }
                    this._model.setValue(value);
                    this._model._triggerUserValue(value);
                    // this._hideOptions();
                    // const listItem = event.target.querySelector(".user-selected");
                    // listItem.click();
                } else {
                    this._clearFilter();
                    this._model.setValue(userSelectedValue);
                    this._model._triggerUserValue(userSelectedValue, value, event);
                    this._hideOptions();
                }
            }
            event.stopImmediatePropagation();
        }

        this._model._triggerUserKeyDown(event);
    }
}

module.exports = OrgsComboRenderer;
